import { siteInfo } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function StatsStrip() {
  return (
    <section className="w-full px-4 md:px-6 py-12 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          <div>
            <p className="text-3xl md:text-4xl font-heading font-bold text-background-50">{siteInfo.stats.totalComics}</p>
            <p className="text-sm text-primary-100 mt-1">漫画资源</p>
          </div>
          <div>
            <p className="text-3xl md:text-4xl font-heading font-bold text-background-50">{siteInfo.stats.dailyUpdate}</p>
            <p className="text-sm text-primary-100 mt-1">每日更新</p>
          </div>
          <div>
            <p className="text-3xl md:text-4xl font-heading font-bold text-background-50">{siteInfo.stats.registeredUsers}</p>
            <p className="text-sm text-primary-100 mt-1">注册用户</p>
          </div>
          <div>
            <p className="text-3xl md:text-4xl font-heading font-bold text-background-50">{siteInfo.stats.monthlyActive}</p>
            <p className="text-sm text-primary-100 mt-1">月活用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}